import React, { useEffect, useState } from "react";
import product1 from "../../assets/images/product1.png";
import FetchData, { GetList } from "../../providers/dataProvider";
import { ProductCategoryBrowser } from "./ProductCategoryBrowser";

export const SubCategory = ({ setProductTab, ProductTab }) => {
  const [search, setSearch] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [listData, setListData] = useState([]);
  const { data: subproductfamily, loading: subproductfamilyLoading } = FetchData(
    "productgroups",
    { familyId: ProductTab?.subCategoryId }
  );

  useEffect(() => {
    if (subproductfamily) {
      setSubCategories(subproductfamily);
    }
  }, [subproductfamily]);

  useEffect(() => {
    if (listData?.data) {
      setSubCategories(listData.data);
    }
  }, [listData]);

  const handleSearch = () => {
    if (search.trim() !== "") {
      GetList("searchproduct", { search: search.trim() }, setListData);
    } else {
      setSubCategories(subproductfamily || []);
    }
  };

  const handleClearSearch = () => {
    setSearch("");
    setSubCategories(subproductfamily || []);
  };

  const handleBack = () => {
    setProductTab({ tab: "MainCategory", id: 0 });
  };

  const handleSelect = (item) => {
    if (item?.hasOwnProperty("productName")) {
      setProductTab({
        tab: "ProductQuotation",
        id: item,
        subCategoryId: ProductTab?.subCategoryId,
        productSubCategoryId: item?.productGroupId,
        title: item?.shortDesc,
        redirectTab: "SubCategory",
      });
    } else {
      setProductTab({
        tab: "ProductSubCategory",
        productSubCategoryId: item?.id,
        subCategoryId: ProductTab?.subCategoryId,
        title: item?.shortDesc,
      });
    }
  };

  return (
    <ProductCategoryBrowser
      title="Select Sub Category"
      search={search}
      items={subCategories}
      loading={subproductfamilyLoading}
      fallbackImage={product1}
      onBack={handleBack}
      onSearch={handleSearch}
      onSearchChange={setSearch}
      onClearSearch={handleClearSearch}
      onSelect={handleSelect}
    />
  );
};
